import { defineComponent } from "@vue/composition-api";
import { GenericModal } from "@Shared/components/modals";
export default defineComponent({
  name: "DeleteDisclaimerModal",
  components: {
    GenericModal
  },
  setup() {}
});